if (!customElements.get('goose-localization')) {
  customElements.define('goose-localization', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.form.addEventListener('change', () => this.form.requestSubmit());
      this.form.addEventListener('submit', (event) => this.change(event));
    }

    async localizeProperties(language, signal) {
      const dataResponse = await fetch(this.dataset.translationsUrl, { signal });
      if (!dataResponse.ok) throw new Error();
      const data = await dataResponse.json();
      const cartUrl = new URL(this.dataset.cartUrl + '.js', location.origin);
      const response = await fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store', signal });
      if (!response.ok) throw new Error();
      const cart = await response.json();
      const target = language === 'en' ? 1 : 0;
      const labels = Object.fromEntries(data.labels.flatMap(pair => pair.map(label => [label, pair[target]])));
      const positions = Object.fromEntries(data.positions.flatMap(pair => pair.map(position => [position, pair[target]])));
      const values = data.values[language];
      for (const item of cart.items) {
        if (!item.properties?._Personalizacion_ID || item.properties._Complemento || item.properties._Servicio) continue;
        const properties = Object.fromEntries(Object.entries(item.properties).map(([key, value]) => {
          const label = labels[key];
          if (!label) return [key, value];
          if (key === 'Posición del grabado' || key === 'Engraving position') return [label, positions[value] || value];
          if (/Detalle de|detail/.test(key)) return [label, String(value).split(' / ').map(part => values[part] || part).join(' / ')];
          return [label, value];
        }));
        if (JSON.stringify(properties) === JSON.stringify(item.properties)) continue;
        const change = await fetch(this.dataset.cartUrl + '/change.js', {
          method: 'POST', credentials: 'same-origin', signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties }),
        });
        if (!change.ok) throw new Error();
      }
    }

    async change(event) {
      event.preventDefault();
      if (this.busy) return;
      const status = this.querySelector('[role="status"]');
      const cartLock = typeof CartItems === 'undefined' ? null : CartItems;
      if (cartLock?.changePending || document.querySelector('goose-hatbar.is-busy')) {
        this.form.reset();
        status.textContent = this.dataset.wait;
        return;
      }
      const language = this.form.elements.language_code.value;
      if (language === this.dataset.currentLanguage) {
        HTMLFormElement.prototype.submit.call(this.form);
        return;
      }
      this.busy = true;
      if (cartLock) cartLock.changePending = true;
      status.textContent = '';
      this.setAttribute('aria-busy', 'true');
      const controls = [...document.querySelectorAll('goose-localization select, cart-drawer button, cart-drawer input, cart-items button, cart-items input, [name="checkout"], [data-goose-discount] button, [data-goose-add] button, [data-goose-add] select, [data-hb-add]')].map(control => ({control, disabled: control.disabled}));
      controls.forEach(({control}) => { control.disabled = true; });
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      let success = false;
      try {
        await this.localizeProperties(language, controller.signal);
        success = true;
      } catch (error) {
        this.form.reset();
        status.textContent = this.dataset.error;
      } finally {
        clearTimeout(timeout);
        controls.forEach(({control, disabled}) => { if (control.isConnected) control.disabled = disabled; });
        if (cartLock) cartLock.changePending = false;
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
      if (success) HTMLFormElement.prototype.submit.call(this.form);
    }
  });
}
